<template>
  <BaseModal
    :is-open="modelValue"
    modal-name="How it works"
    class="p-0 max-w-2xl bg-linen"
    no-margin-top
    @update:is-open="$emit('update:modelValue', $event)"
  >
    <template #closeBtn>
      <div class="flex absolute top-4 right-4 z-50 flex-1 justify-end items-center px-2 py-1">
        <button
          cy-data="modal-close-btn"
          class="flex justify-center items-center self-end p-2 rounded-full bg-linen"
          @click="$emit('update:modelValue', false)"
        >
          <XIcon class="size-4 text-terracota-dark" />
        </button>
      </div>
    </template>
    <HowItWorksModalContent @close="$emit('update:modelValue', false)" />
  </BaseModal>
</template>

<script lang="ts" setup>
  import { XIcon } from '@heroicons/vue/solid';
  import BaseModal from '@/components/BaseModal.vue';
  import HowItWorksModalContent from '@/components/HowItWorksModalContent.vue';

  interface Props {
    modelValue?: boolean;
  }

  withDefaults(defineProps<Props>(), { modelValue: false });

  interface Emits {
    (e: 'update:modelValue', value: boolean): void;
  }

  defineEmits<Emits>();
</script>
